import { Auth } from '@opoint/authjs'
import Cookies from 'js-cookie'
import { BASE_URL } from "@/constants";

export const TOKEN_KEY = 'token'

export const authModule = {
  namespaced: true,
  state: () => ({
    auth: null
  }),
  mutations: {
    logOut(state) {
      state.auth.logout()
      Cookies.remove('token')
    }
  },
  actions: {
    /**
     * Initializes auth store. Only reject promise if invalid token (because not being
     * logged in is a completely valid state for the auth store)
     *
     * @param commit
     * @param state
     * @param token
     * @returns {Promise<unknown>}
     */
    async init({ state }) {
      const callback = window.location.origin + BASE_URL;
      state.auth = new Auth('https://auth.opoint.com', callback, true, true)
      await state.auth.getState() // This ensures the autologin triggers right away
    }
  },
  getters: {
    isLoggedIn(state) {
      return !!(state.auth && state.auth.state)
    },
  }
}
